import { ReactNode, createContext, useContext } from "react";

export type LayerPositionType =
| 'bottom'
| 'bottom-left'
| 'bottom-right'
| 'center'
| 'hidden'
| 'left'
| 'right'
| 'top'
| 'top-left'
| 'top-right';

export type NotificationMessage = {
  id?: string
  icon?: ReactNode
  title?: string
  message: string | ReactNode
  status?: "unknown" | "normal" | "warning" | "info" | "critical"
  timeout?: number
  toast?: {
    autoClose: boolean,
    position: LayerPositionType
  } | boolean
  actions?: (ReactNode | ((toast: ToastApi) => ReactNode))[]
}

export type ToastApi = {
  close: () => void
}

export type NotificationContextType = {
  showNotification: (notification: NotificationMessage) => void;
}

export const NotificationContext = createContext<NotificationContextType>(undefined!);

export const useNotifications = () => {
  return useContext(NotificationContext);
}